import { render, staticRenderFns } from "./HelpOther.vue?vue&type=template&id=32850504&scoped=true&"
import script from "./HelpOther.vue?vue&type=script&lang=js&"
export * from "./HelpOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32850504",
  null
  
)

export default component.exports